import Vue from 'vue'
import Vuetify, {
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VToolbar,
  VCard,
  VChip,
  VForm,
  VTextField,
  VDataTable,
  VTabs,
  VProgressCircular,
  VCheckbox,
  VTooltip,
  VDialog,
  VSelect,
  VAvatar,
  VDatePicker,
  VDivider,
  VSlider,
  VMenu,
  VProgressLinear
} from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VToolbar,
    VCard,
    VChip,
    VForm,
    VTextField,
    VDataTable,
    VTabs,
    VProgressCircular,
    VCheckbox,
    VTooltip,
    VDialog,
    VSelect,
    VAvatar,
    VDatePicker,
    VDivider,
    VSlider,
    VMenu,
    VProgressLinear
  },
  iconfont: 'md',
  theme: {
    //primary: '#27408b',
    primary: '#F15550', //vemelll principal
    //secondary: '#1E88E5',
    secondary: '#27408b', //blau clasic
    accent: '#FF8F00',
    error: '#c12701',
    warning: '#6D4C41',
    info: '#FDD835',
    success: '#4caf50',
    background: '#F91F1F' //gris fosc
  }
})
